// A4 racun s kase.
//
// Koristi se najvise kad je placanje transakcijskim racunom: kupac racun tek
// treba platiti, pa mu treba list s podacima za uplatu i 2D kodom - traka od
// 80 mm za to ne sluzi. Sluzi i kao zamjena kad pisac trake ne radi, da se
// racun uvijek moze dati kupcu.
//
// Ulaz je ISTI objekt koji ide i na traku (gradi ga posluzitelj iz retka
// "Pos"), plus blok "a4" s podacima za placanje. Namjerno ne cita redak
// "Documents" ni store - kasa s dokumentima nema veze.
//
// Dva koda na papiru rade razlicite stvari i ne smiju se zamijeniti:
//   QR    -> poveznica na Poreznu upravu, provjera je li racun prijavljen
//   PDF417 (HUB3A) -> kupcev mobilni bankar ga ocita i ispuni nalog

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import generateBarcode from 'pdf417'
import moneyFormat from '@/snippets/moneyFormat'

const novac = (v) => moneyFormat(v)

/**
 * HUB3A zapis za 2D kod. Redoslijed redaka je propisan i ne smije se mijenjati.
 * Iznos je 15 znamenki s vodecim nulama, bez decimalne tocke.
 */
const hub3 = (p) => {
  const a = p.a4 || {}
  const platitelj = a.platitelj || {}
  const iznos = Math.round(Math.abs(Number(p.total) || 0) * 100)
  const uIznos = String(iznos).padStart(15, '0')
  const ili = (v) => (v && String(v).trim() ? String(v).trim() : ' ')

  return 'HRVHUB30\n' +
    'EUR\n' +
    uIznos + '\n' +
    ili(platitelj.naziv) + '\n' +
    ili(platitelj.adresa) + '\n' +
    ili(platitelj.mjesto) + '\n' +
    ili(p.seller && p.seller.name) + '\n' +
    ili(p.seller && p.seller.address) + '\n' +
    ili(p.seller && p.seller.city) + '\n' +
    ili(a.iban) + '\n' +
    ili(a.model) + '\n' +
    ili(a.pozivNaBroj) + '\n' +
    'COST\n' +
    ili(a.opis) + '\n'
}

const zaglavlje = (p) => ({
  columns: [
    {
      width: '60%',
      stack: [
        {text: p.seller.name || '', fontSize: 14, bold: true},
        {text: p.seller.address || '', fontSize: 9},
        {text: p.seller.city || '', fontSize: 9},
        {text: p.seller.phone ? 'Tel: ' + p.seller.phone : '', fontSize: 9},
        {text: p.seller.taxId ? 'OIB: ' + p.seller.taxId : '', fontSize: 9}
      ]
    },
    {
      width: '40%',
      stack: [
        {text: 'RAČUN', fontSize: 16, bold: true, alignment: 'right'},
        {text: p.number || '', fontSize: 13, bold: true, alignment: 'right'},
        {text: p.date || '', fontSize: 9, alignment: 'right'},
        {text: p.cashier ? 'Operater: ' + p.cashier : '', fontSize: 9, alignment: 'right'}
      ]
    }
  ]
})

const kupac = (p) => {
  const c = p.customer || {}
  if (!c.name) {
    return {text: 'Kupac: fizička osoba', fontSize: 9, margin: [0, 16, 0, 0]}
  }
  const a = (p.a4 && p.a4.platitelj) || {}
  return {
    margin: [0, 16, 0, 0],
    stack: [
      {text: 'Kupac', fontSize: 8, color: '#666'},
      {text: c.name, fontSize: 11, bold: true},
      {text: a.adresa || '', fontSize: 9},
      {text: a.mjesto || '', fontSize: 9},
      {text: c.taxId || '', fontSize: 9}
    ]
  }
}

const stavke = (p) => {
  const redci = [[
    {text: '#', style: 'th'},
    {text: 'Artikl', style: 'th'},
    {text: 'Kol.', style: 'th', alignment: 'right'},
    {text: 'Mj.', style: 'th', alignment: 'center'},
    {text: 'Cijena', style: 'th', alignment: 'right'},
    {text: 'Popust', style: 'th', alignment: 'right'},
    {text: 'PDV', style: 'th', alignment: 'right'},
    {text: 'Iznos', style: 'th', alignment: 'right'}
  ]]

  ;(p.items || []).forEach((s, i) => {
    redci.push([
      {text: String(i + 1), fontSize: 9},
      {text: s.name || '', fontSize: 9},
      {text: novac(s.quantity), fontSize: 9, alignment: 'right'},
      {text: s.unit || '', fontSize: 9, alignment: 'center'},
      {text: novac(s.unitPrice), fontSize: 9, alignment: 'right'},
      {text: s.discount ? '-' + novac(s.discount) : '', fontSize: 9, alignment: 'right'},
      {text: novac(s.taxRate) + ' %', fontSize: 9, alignment: 'right'},
      {text: novac(s.total), fontSize: 9, alignment: 'right', bold: true}
    ])
  })

  return {
    margin: [0, 16, 0, 0],
    table: {headerRows: 1, widths: [14, '*', 40, 24, 52, 46, 36, 56], body: redci},
    layout: {
      hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length ? 0.8 : 0.3),
      vLineWidth: () => 0,
      hLineColor: (i) => (i === 1 ? '#1976d2' : '#cfd8dc'),
      paddingTop: () => 4,
      paddingBottom: () => 4
    }
  }
}

const zbroj = (p) => {
  const redci = []
  ;(p.taxes || []).forEach(t => {
    redci.push([
      {text: `Osnovica ${novac(t.rate)} %`, fontSize: 9, alignment: 'right'},
      {text: novac(t.base), fontSize: 9, alignment: 'right'}
    ])
    redci.push([
      {text: `PDV ${novac(t.rate)} %`, fontSize: 9, alignment: 'right'},
      {text: novac(t.amount), fontSize: 9, alignment: 'right'}
    ])
  })
  if (p.discount) {
    redci.push([
      {text: 'Popust', fontSize: 9, alignment: 'right'},
      {text: '-' + novac(p.discount), fontSize: 9, alignment: 'right'}
    ])
  }
  redci.push([
    {text: 'ZA PLATITI', fontSize: 12, bold: true, alignment: 'right', margin: [0, 4, 0, 0]},
    {text: novac(p.total) + ' EUR', fontSize: 12, bold: true, alignment: 'right', margin: [0, 4, 0, 0]}
  ])

  return {
    margin: [0, 12, 0, 0],
    columns: [
      {width: '*', text: ''},
      {
        width: 220,
        table: {widths: ['*', 76], body: redci},
        layout: {
          hLineWidth: (i, node) => (i === node.table.body.length - 1 ? 0.8 : 0),
          vLineWidth: () => 0,
          hLineColor: () => '#1976d2',
          paddingTop: () => 2,
          paddingBottom: () => 2
        }
      }
    ]
  }
}

const placanje = (p) => {
  const a = p.a4 || {}
  const nacin = (p.payments && p.payments[0] && p.payments[0].method) || ''
  const stack = [{text: 'Način plaćanja: ' + nacin, fontSize: 9, bold: true}]

  // Podaci za uplatu imaju smisla samo kad racun tek treba platiti. Uz
  // gotovinu ili karticu je vec placen, pa bi nalog samo zbunjivao.
  if (p.placeno !== true && a.iban) {
    stack.push({text: ' ', fontSize: 4})
    stack.push({text: 'Podaci za uplatu', fontSize: 8, color: '#666'})
    stack.push({text: 'IBAN: ' + a.iban + (a.banka ? '  (' + a.banka + ')' : ''), fontSize: 9})
    stack.push({text: 'Model i poziv na broj: ' + a.model + '  ' + a.pozivNaBroj, fontSize: 9})
    stack.push({text: 'Opis: ' + (a.opis || ''), fontSize: 9})
  }
  if (p.change) {
    stack.push({text: 'Povrat: ' + novac(p.change) + ' EUR', fontSize: 9})
  }
  return {margin: [0, 18, 0, 0], stack: stack}
}

// Dolje na listu: lijevo 2D kod za placanje, desno QR Porezne.
const kodovi = (p, slika2D) => {
  const lijevo = slika2D
    ? {
        width: 'auto',
        stack: [
          {text: '2D kod za plaćanje', fontSize: 8, color: '#666', margin: [0, 0, 0, 3]},
          {image: slika2D, fit: [200, 100]}
        ]
      }
    : {width: '*', text: ''}

  const qr = p.fiscal && p.fiscal.qr
  const desno = qr
    ? {
        width: 'auto',
        alignment: 'right',
        stack: [
          {text: 'Provjera računa', fontSize: 8, color: '#666', alignment: 'right', margin: [0, 0, 0, 3]},
          {qr: qr, fit: 86, alignment: 'right'}
        ]
      }
    : {width: '*', text: ''}

  return {margin: [0, 20, 0, 0], columns: [lijevo, {width: '*', text: ''}, desno]}
}

const fiskalni = (p) => {
  const f = p.fiscal || {}
  const redci = []
  if (f.JIR) { redci.push({text: 'JIR: ' + f.JIR, fontSize: 8}) }
  if (f.ZKI) { redci.push({text: 'ZKI: ' + f.ZKI, fontSize: 8}) }
  if (!redci.length) {
    // Racun bez JIR-a se smije izdati, ali to mora pisati na papiru.
    redci.push({text: 'Račun nije fiskaliziran.', fontSize: 8, color: '#c62828'})
  }
  redci.push({text: (p.branch && p.branch.code ? 'Poslovni prostor: ' + p.branch.code : ''), fontSize: 8})
  return {margin: [0, 14, 0, 0], stack: redci}
}

/**
 * Napravi A4 racun i vrati poveznicu na njega (blob URL).
 *
 * NAMJERNO ne koristi pdfMake.open(): ono otvara skocni prozor, a preglednici
 * ga blokiraju cim poziv ne dode ravno iz klika - a ovdje dolazi tek nakon
 * spremanja i fiskalizacije. Provjereno: u ovoj aplikaciji je blokiran, pa bi
 * kupac ostao bez racuna. Umjesto toga se PDF prikazuje unutar aplikacije,
 * odakle se ispisuje ili sprema.
 *
 * @param {Object} podaci  isti objekt koji ide i na traku, s blokom "a4"
 * @returns {Promise<string>} blob URL
 */
export const pdfA4 = (podaci) => {
  const p = podaci || {}
  if (pdfFonts && pdfFonts.pdfMake) { pdfMake.vfs = pdfFonts.pdfMake.vfs }

  let slika2D = null
  try {
    if (p.a4 && p.a4.iban) { slika2D = generateBarcode(hub3(p), 4, 2) }
  } catch (e) {
    // Bez 2D koda racun je i dalje valjan - IBAN i poziv na broj su ispisani
    // slovima iznad, pa se nalog moze ispuniti rucno.
    slika2D = null
  }

  const sadrzaj = [
    zaglavlje(p),
    kupac(p),
    stavke(p),
    zbroj(p),
    placanje(p),
    kodovi(p, slika2D),
    fiskalni(p),
    {text: p.footer || '', fontSize: 9, alignment: 'center', margin: [0, 18, 0, 0]}
  ]

  const dokument = pdfMake.createPdf({
    pageSize: 'A4',
    pageMargins: [40, 40, 40, 40],
    content: sadrzaj,
    styles: {th: {fontSize: 8, bold: true, color: '#1565c0'}},
    defaultStyle: {fontSize: 10}
  })

  return new Promise((rijesi, odbij) => {
    try {
      dokument.getBlob((blob) => rijesi(window.URL.createObjectURL(blob)))
    } catch (e) {
      odbij(e)
    }
  })
}


// ---------------------------------------------------------------------------
// Obracun kase na A4
// ---------------------------------------------------------------------------

const obracunZaglavlje = (o) => ({
  columns: [
    {
      width: '60%',
      stack: [
        {text: o.firma.naziv || '', fontSize: 14, bold: true},
        {text: o.firma.oib ? 'OIB: ' + o.firma.oib : '', fontSize: 9},
        {
          text: [o.firma.oznPosPr, o.firma.oznNapUr].filter(x => x).length
            ? `Poslovni prostor ${o.firma.oznPosPr} / naplatni uređaj ${o.firma.oznNapUr}`
            : '',
          fontSize: 9
        }
      ]
    },
    {
      width: '40%',
      stack: [
        {text: 'OBRAČUN KASE', fontSize: 16, bold: true, alignment: 'right'},
        {
          text: o.razdoblje.jedanDan
            ? uNasDatum(o.razdoblje.od)
            : uNasDatum(o.razdoblje.od) + ' – ' + uNasDatum(o.razdoblje.do),
          fontSize: 13, bold: true, alignment: 'right'
        },
        {
          text: o.odBroja ? `Računi ${o.odBroja} – ${o.doBroja}` : 'Nema računa',
          fontSize: 9, alignment: 'right'
        }
      ]
    }
  ]
})

const uNasDatum = (d) => {
  const x = String(d || '').slice(0, 10).split('-')
  return x.length === 3 ? `${x[2]}.${x[1]}.${x[0]}` : String(d || '')
}

const obracunTablica = (naslovi, redci, sirine) => ({
  margin: [0, 10, 0, 0],
  table: {
    headerRows: 1,
    widths: sirine,
    body: [naslovi.map(n => ({text: n.tekst, style: 'th', alignment: n.desno ? 'right' : 'left'}))]
      .concat(redci)
  },
  layout: {
    hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length ? 0.8 : 0.3),
    vLineWidth: () => 0,
    hLineColor: (i) => (i === 1 ? '#1976d2' : '#cfd8dc'),
    paddingTop: () => 4,
    paddingBottom: () => 4
  }
})

const red = (celije) => celije.map((c, i) => ({
  text: c.t, fontSize: 9, alignment: c.desno ? 'right' : 'left', bold: c.bold === true
}))

/**
 * Obracun kase -> A4 PDF. Vraca blob URL, kao i racun.
 */
export const pdfObracunA4 = (o) => {
  if (pdfFonts && pdfFonts.pdfMake) { pdfMake.vfs = pdfFonts.pdfMake.vfs }

  const sadrzaj = [obracunZaglavlje(o)]

  // Ukupno - ono zbog cega se obracun i radi, pa ide prvo i krupno.
  sadrzaj.push({
    margin: [0, 18, 0, 0],
    table: {
      widths: ['*', 110],
      body: [
        [
          {text: `UKUPNO  (${o.ukupno.brojRacuna} ${o.ukupno.brojRacuna === 1 ? 'račun' : 'računa'})`,
            fontSize: 13, bold: true, color: '#1565c0'},
          {text: novac(o.ukupno.iznos) + ' EUR', fontSize: 15, bold: true,
            alignment: 'right', color: '#1565c0'}
        ]
      ]
    },
    layout: {
      hLineWidth: () => 0.8, vLineWidth: () => 0, hLineColor: () => '#1976d2',
      paddingTop: () => 6, paddingBottom: () => 6
    }
  })

  sadrzaj.push({text: 'Po stopama PDV-a', fontSize: 11, bold: true, margin: [0, 18, 0, 0]})
  sadrzaj.push(obracunTablica(
    [{tekst: 'Stopa'}, {tekst: 'Osnovica', desno: true}, {tekst: 'PDV', desno: true}, {tekst: 'Ukupno', desno: true}],
    (o.poStopama || []).map(g => red([
      {t: novac(g.stopa) + ' %'},
      {t: novac(g.osnovica), desno: true},
      {t: novac(g.pdv), desno: true},
      {t: novac(g.ukupno), desno: true, bold: true}
    ])).concat([red([
      {t: 'Ukupno', bold: true},
      {t: novac(o.ukupno.osnovica), desno: true, bold: true},
      {t: novac(o.ukupno.pdv), desno: true, bold: true},
      {t: novac(o.ukupno.iznos), desno: true, bold: true}
    ])]),
    ['*', 110, 110, 110]
  ))

  sadrzaj.push({text: 'Po načinu plaćanja', fontSize: 11, bold: true, margin: [0, 18, 0, 0]})
  sadrzaj.push(obracunTablica(
    [{tekst: 'Način'}, {tekst: 'Računa', desno: true}, {tekst: 'Iznos', desno: true}],
    (o.poPlacanju || []).map(p => red([
      {t: p.naziv},
      {t: String(p.brojRacuna), desno: true},
      {t: novac(p.iznos), desno: true, bold: true}
    ])).concat([red([
      {t: 'Ukupno', bold: true},
      {t: String(o.ukupno.brojRacuna), desno: true, bold: true},
      {t: novac(o.ukupno.iznos), desno: true, bold: true}
    ])]),
    ['*', 110, 110]
  ))

  // Razrada po danima ima smisla tek kad razdoblje obuhvaca vise dana.
  if (!o.razdoblje.jedanDan && (o.poDanima || []).length > 1) {
    sadrzaj.push({text: 'Po danima', fontSize: 11, bold: true, margin: [0, 18, 0, 0]})
    sadrzaj.push(obracunTablica(
      [{tekst: 'Datum'}, {tekst: 'Računa', desno: true}, {tekst: 'Osnovica', desno: true},
        {tekst: 'PDV', desno: true}, {tekst: 'Iznos', desno: true}],
      o.poDanima.map(d => red([
        {t: uNasDatum(d.datum)},
        {t: String(d.brojRacuna), desno: true},
        {t: novac(d.osnovica), desno: true},
        {t: novac(d.pdv), desno: true},
        {t: novac(d.iznos), desno: true, bold: true}
      ])),
      ['*', 70, 90, 90, 100]
    ))
  }

  // Nefiskalizirani ulaze u zbroj, ali se moraju vidjeti: to je ono sto jos
  // treba poslati Poreznoj.
  if (o.nefiskalizirani && o.nefiskalizirani.brojRacuna) {
    sadrzaj.push({
      margin: [0, 18, 0, 0],
      table: {
        widths: ['*'],
        body: [[{
          text: `Bez JIR-a: ${o.nefiskalizirani.brojRacuna} ` +
            `${o.nefiskalizirani.brojRacuna === 1 ? 'račun' : 'računa'}, ` +
            `${novac(o.nefiskalizirani.iznos)} EUR. ` +
            'Ti su računi u zbroju iznad — novac je naplaćen — ali još nisu prijavljeni Poreznoj.',
          fontSize: 9, color: '#8d6e00', margin: [6, 5, 6, 5]
        }]]
      },
      layout: {
        hLineWidth: () => 0.8, vLineWidth: () => 0.8,
        hLineColor: () => '#f0d78a', vLineColor: () => '#f0d78a'
      }
    })
  }

  sadrzaj.push({
    text: `Izradio: ${o.izradio || ''}   ·   ${o.izradeno || ''}`,
    fontSize: 8, color: '#666', margin: [0, 22, 0, 0]
  })

  const dokument = pdfMake.createPdf({
    pageSize: 'A4',
    pageMargins: [40, 40, 40, 40],
    content: sadrzaj,
    styles: {th: {fontSize: 8, bold: true, color: '#1565c0'}},
    defaultStyle: {fontSize: 10}
  })

  return new Promise((rijesi, odbij) => {
    try {
      dokument.getBlob((blob) => rijesi(window.URL.createObjectURL(blob)))
    } catch (e) {
      odbij(e)
    }
  })
}

export default {pdfA4, pdfObracunA4, hub3}
